import Config from "../../navigators/RootNavigator/services/Config";
import { buildTheme } from "./utilities";
const Theme = buildTheme(Config.color);
export default Theme;
